import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

interface CancelTreatmentParams {
  treatmentId: string
  reason: string
  patientId: string
}

/** Cancels an active treatment with a mandatory reason. */
export function useCancelTreatment() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ treatmentId, reason }: CancelTreatmentParams) => {
      const response = await api.post('/treatments/:id/cancel', {
        params: { id: treatmentId },
        body: { reason },
      })
      if (!response.success) throw new Error(response.error.message)
    },
    onSuccess: (_data, { patientId }) => {
      queryClient.invalidateQueries({ queryKey: ['patient-treatments', patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', patientId] })
    },
  })
}
